import { Accepted, Cookie, cookies, getCookie } from '../../utils/cookies'
import { getCurrentCookies } from '../../utils/datalayer.mapping'

export type CookiebarState = {
  cookies: Map<Cookie, Accepted>
  expandOptions: boolean
  cookieBarVisible: boolean
}

export const initialCookiebarState = (): CookiebarState => {
  const currentCookies = getCurrentCookies()
  return {
    cookies: currentCookies,
    expandOptions: false,
    cookieBarVisible: getCookie('showCookies') !== 'no',
  }
}

export const cookiebarStateUpdaters = {
  cookiebarVisibleUpdater: (currentState: CookiebarState): CookiebarState => ({
    ...currentState,
    cookieBarVisible: true,
  }),
  expandOptionsUpdater: (currentState: CookiebarState): CookiebarState => ({
    ...currentState,
    expandOptions: !currentState.expandOptions,
  }),
  singleCookieUpdater:
    (cookie: Cookie, isAccepted: Accepted) =>
    (currentState: CookiebarState): CookiebarState => ({
      ...currentState,
      cookies: currentState.cookies.set(cookie, isAccepted),
    }),
  allCookiesUpdater:
    (isAccepted: Accepted) =>
    (currentState: CookiebarState): CookiebarState => ({
      ...currentState,
      cookies: cookies.reduce(
        (prev, curr) => prev.set(curr, isAccepted),
        currentState.cookies
      ),
      cookieBarVisible: false,
    }),
  applyCookiesUpdater: (currentState: CookiebarState): CookiebarState => ({
    ...currentState,
    cookies: currentState.cookies,
    cookieBarVisible: false,
  }),
}
